import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=6bb641e0&"
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"
import style0 from "./feedback.vue?vue&type=style&index=0&id=6bb641e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzTextField: require('/opt/airport.kg/node_modules/razlet-ui/src/components/text-field/index.vue').default,BasePhoneInput: require('/opt/airport.kg/src/components/base/phone-input.vue').default,RzFileField: require('/opt/airport.kg/node_modules/razlet-ui/src/components/file-field/index.vue').default,RzTextarea: require('/opt/airport.kg/node_modules/razlet-ui/src/components/textarea/index.vue').default,RzCheckbox: require('/opt/airport.kg/node_modules/razlet-ui/src/components/checkbox/index.vue').default,RzButton: require('/opt/airport.kg/node_modules/razlet-ui/src/components/button/index.js').default,Sulu: require('/opt/airport.kg/node_modules/razlet-sulu-sdk/src/components/index.vue').default})
